function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "locked_inline_svg__Icon_metro-lock",
  "data-name": "Icon metro-lock",
  d: "M6.427 20.84v-9.37h1.74V8.541a4.663 4.663 0 014.642-4.685h.58a4.664 4.664 0 014.642 4.685v2.929h1.741v9.37H6.427zm6.234-4.81l-.432 3.053h1.741l-.432-3.053a1.16 1.16 0 10-.877 0zm3.63-7.2a3.191 3.191 0 10-6.382 0v2.64h6.381z",
  transform: "translate(-6.427 -3.856)",
  fill: "#fdf7ec"
});

function SvgLockedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.345,
    height: 16.984,
    viewBox: "0 0 13.345 16.984"
  }, props), _ref);
}

export default SvgLockedinline;